import React, {Fragment, useCallback } from "react";
import FormField from "../components/FormField";
import { required, email, length } from 'redux-form-validators'
import { isPossiblePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { Field } from "redux-form";
import { useTranslation } from 'react-i18next';
import GoogleAddressAutoComplete from '../components/GoogleAddressAutoComplete';
//import {
//    //KendoInput,
//    //KendoNumericTextBox,
//    //KendoDatePicker,
//    KendoDropDown
//} from '../components/FormEditors';


export default function (props) {
    const { t } = useTranslation();
    const { settings, isProfile } = props;
    const passwordValidations = isProfile ? [] : [required({ msg: t("is required") }), length({ min: 6 })];
    const phoneValidation = useCallback((value, allValues, props, name) => {
         if (!value) {
            return undefined;
            }
        try {
            let isoCodes = settings.googleGeoFilterCountriesCodes.toString().split(',');
            let isValidPhoneNumberFlag = isoCodes.some(element =>
                isPossiblePhoneNumber(value, element.toString().toUpperCase()) &&
                isValidPhoneNumber(value, element.toString().toUpperCase())
            );

            if (isValidPhoneNumberFlag) {
                return undefined;
            }
            else {
                return t("Invalid phone number, please provide a valid mobile or landline number in") + " " + settings.googleGeoFilterCountriesCodes.toString().toUpperCase();
            }
        } catch (error) {
            console.log(error)
            return t("Invalid phone number, please provide a valid phone number in " + settings.locale.toString().toUpperCase());
        }
    }, [settings, t]);

    return (
        <Fragment>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="titleId">{t("Title")} </label>
                    <Field name="titleId" component={FormField}
                        validate={[required({msg: t("is required")})]}
                        className="form-control">
                        <option value="">{t("Select a title")}</option>
                        {settings.titles && settings.titles.map(option => <option value={option.id} key={option.id}>{option.name}</option>)}

                    </Field>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="firstName">{t("First Name")} </label>
                    <Field
                        className="form-control"
                        type="text"
                        name="firstName"
                        icon="icon-head"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("First Name")}
                        validate={[required({msg: t("is required")})]}
                    />
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="lastName">{t("Last Name")}</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="lastName"
                        icon="icon-head"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Last Name")}
                        validate={[required({msg: t("is required")})]}
                    />
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="email">{t("Email")}</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="email"
                        icon="icon-mail"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Email")}
                        validate={[required({ msg: t("is required") }), email({ msg: t("is invalid email") })]}
                    />
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="phone">{t("Phone")}</label>
                    <Field
                        className="form-control"
                        type="tel"
                        name="phone"
                        icon="pe-7s-phone"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Phone")}
                         validate={[
                                        required({ msg: t("is required") }),
                                        length({ max: 25, allowBlank: false, msg: t('is too long (max is {count, number} characters)') }),
                                        phoneValidation
                                   ]}
                    />
                </div>
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="phone">{t("Mobile")}</label>
                    <Field
                        className="form-control"
                        type="tel"
                        name="mobile"
                        icon="pe-7s-phone"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Mobile")}
                       validate={[
                                    length({ max: 25, allowBlank: true, msg: { max: t('is too long (max is {count, number} characters)') } }),
                                    phoneValidation
                                 ]}
                    />
                </div>
            </div>
            <div className="col-sm-6 col-md-3">
                <div className="form-group">
                    <label htmlFor="password">{t("Password")}</label>
                    <Field
                        className="form-control"
                        type="password"
                        name="password"
                        icon="icon-lock"
                        autoComplete={props.allowPasswordAutoComplete ? "new-password" : "chrome-off"}
                        component={FormField}
                        placeholder={t("Password")}
                        validate={passwordValidations}
                    />
                </div>
            </div>
            <div className="col-sm-6 col-md-3">
                <div className="form-group">
                    <label htmlFor="confirmPassword">{t("Confirm Password")}</label>
                    <Field
                        className="form-control"
                        type="password"
                        name="confirmPassword"
                        icon="icon-lock"
                        autoComplete={props.allowPasswordAutoComplete ? "new-password" : "chrome-off"}
                        component={FormField}
                        placeholder={t("Confirm Password")}
                        validate={passwordValidations}
                    />
                </div>
            </div>

            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="region">{t("Region")}</label>
                    <Field name="regionId"
                        component={FormField}
                        className="form-control"
                        validate={[required({msg: t("is required")})]}>
                        <option value="">{t("Select a region")}</option>
                        {settings.deliveryRegions && settings.deliveryRegions.map(option => <option value={option.id} key={option.id}>{option.name}</option>)}
                    </Field>

                </div>
            </div>
            <div className="col-sm-12">
                {settings.useAddressAutoCompleteInVipShop && settings.googleKey && <GoogleAddressAutoComplete settings={settings} onChange={props.onGoogleAddressChange.bind(this)} />}
            </div>
            <div className="col-sm-6">
                <div className="form-group">
                    <label htmlFor="address1">{t("Address 1")}</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="address1"
                        icon="icon-globe"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Address 1")}
                        validate={[required({msg: t("is required")})]}
                    />
                </div>
            </div>
            <div className="col-sm-6 atw-hide no-hide se-hide fi-hide">
                <div className="form-group">
                    <label htmlFor="address2">{t("Address 2")}</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="address2"
                        icon="icon-globe"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Address 2")}
                    />
                </div>
            </div>
            <div className="col-sm-6 atw-hide no-hide se-hide fi-hide">
                <div className="form-group">
                    <label htmlFor="address3">{t("Address 3")}</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="address3"
                        icon="icon-globe"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("Address 3")}
                    />
                </div>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-2">
                <div className="form-group">
                    <label htmlFor="postCode">{t("PostCode")}</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="postCode"
                        icon="icon-globe"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("PostCode")}
                        validate={[required({msg: t("is required")})]}
                    />
                </div>
            </div>
            <div className="col-sm-6 col-md-3 col-lg-4">
                <div className="form-group">
                    <label htmlFor="address4">{t("City/County")}:</label>
                    <Field
                        className="form-control"
                        type="text"
                        name="address4"
                        icon="icon-globe"
                        autoComplete="chrome-off"
                        component={FormField}
                        placeholder={t("City/County")}
                        validate={[required({msg: t("is required")})]}
                    />
                </div>
            </div>
        </Fragment>
    );

}
